var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"doughnutChart",staticStyle:{"display":"flex","width":"100%","height":"90%","align-items":"center","justify-content":"center"}})
}
var staticRenderFns = []

export { render, staticRenderFns }